import { initializeApp, getApps } from 'firebase/app';
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase config for authentication (existing app)
const firebaseConfig = {
    apiKey: "AIzaSyBHTGyA0QAzO3gHocNPnkXesicfijhON9M",
    authDomain: "irrig-a7fd5.firebaseapp.com",
    databaseURL: "https://irrig-a7fd5.firebaseio.com",
    projectId: "irrig-a7fd5",
    storageBucket: "irrig-a7fd5.appspot.com",
    messagingSenderId: "729031097299",
    appId: "1:729031097299:web:de13426929e93bbac2cd26",
    measurementId: "G-JVW0M6JQ81"
};

// Initialize Firebase app for authentication
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Firebase config for tickets (master-dash-fdd8c project)
// This is ONLY used for ticket support storage, nothing else
const ticketFirebaseConfig = {
    apiKey: process.env.VUE_APP_SUPPORT_FIREBASE_API_KEY || 
            process.env.SUPPORT_FIREBASE_API_KEY || 
            "AIzaSyDsy9EL3XdnKeRgCFPdRdQ7yyzEgoe5dps",
    authDomain: process.env.VUE_APP_SUPPORT_FIREBASE_AUTH_DOMAIN || 
                process.env.SUPPORT_FIREBASE_AUTH_DOMAIN || 
                "master-dash-fdd8c.firebaseapp.com",
    databaseURL: process.env.VUE_APP_SUPPORT_FIREBASE_DATABASE_URL || 
                 process.env.SUPPORT_FIREBASE_DATABASE_URL || 
                 "https://master-dash-fdd8c.firebaseio.com",
    projectId: process.env.VUE_APP_SUPPORT_FIREBASE_PROJECT_ID || 
               process.env.SUPPORT_FIREBASE_PROJECT_ID || 
               "master-dash-fdd8c",
    storageBucket: process.env.VUE_APP_SUPPORT_FIREBASE_STORAGE_BUCKET || 
                   process.env.SUPPORT_FIREBASE_STORAGE_BUCKET || 
                   "master-dash-fdd8c.firebasestorage.app",
    messagingSenderId: process.env.VUE_APP_SUPPORT_FIREBASE_MESSAGING_SENDER_ID || 
                       process.env.SUPPORT_FIREBASE_MESSAGING_SENDER_ID || 
                       "328429523370",
    appId: process.env.VUE_APP_SUPPORT_FIREBASE_APP_ID || 
           process.env.SUPPORT_FIREBASE_APP_ID || 
           "1:328429523370:web:37db59b520edfc0ffb5bd3"
};

// Initialize separate Firebase app for tickets
// Always use master-dash-fdd8c project for tickets (hardcoded fallback ensures it works)
let ticketApp = null;
let ticketDb = null;

if (ticketFirebaseConfig.projectId && ticketFirebaseConfig.apiKey) {
    // Check if ticket app already exists
    const existingApps = getApps();
    ticketApp = existingApps.find(app => app.name === 'ticket-firebase') || 
                initializeApp(ticketFirebaseConfig, 'ticket-firebase');
    ticketDb = getFirestore(ticketApp);
    console.log('✅ Ticket Firestore initialized with project:', ticketFirebaseConfig.projectId);
} else {
    // This should not happen with hardcoded fallbacks, but just in case
    console.error('❌ Ticket Firebase config is missing! Using main Firebase app as fallback.');
    ticketDb = getFirestore(app);
}

// Export main db (for tickets) and auth (for existing app)
const db = ticketDb || getFirestore(app);

export { auth, db, RecaptchaVerifier, signInWithPhoneNumber, firebaseConfig, ticketFirebaseConfig };
